import { CheckBoxCard } from 'components/core';

export interface CardOption {
  id: string;
  label: string;
  desc?: string;
  /** Shown greyed out and not clickable. */
  disabled?: boolean;
}

interface OptionCardsProps {
  cards: CardOption[];
  selected: string[];
  onSelect: (id: string) => void;
}

// A grid of selectable cards, built on the same CheckBoxCard the Access and Dashboards tabs use.
export const OptionCards = ({ cards, selected, onSelect }: OptionCardsProps) => (
  <div className="row">
    {cards.map((c) => (
      <div className={`col-sm-12 col-md-6 col-lg-6 mt-3 ${c.disabled ? 'opacity-50' : ''}`} key={c.id}>
        <CheckBoxCard
          label={c.label}
          subLabel={c.desc}
          isChecked={selected.includes(c.id)}
          clickHandler={c.disabled ? undefined : () => onSelect(c.id)}
        />
      </div>
    ))}
  </div>
);
